import { gridApisI } from "./Interface";

export const GridApis: gridApisI = {
    getRefineProducts: "connector/product/getRefineProducts",
    getRefineProductCount: "connector/product/getRefineProductCount",
    searchProduct: 'connector/product/searchProduct',             // amazonLookupBulk
    matchProduct: 'connector/product/matchProduct',               //amazonSync
    getFilterAttributes: 'connector/source/getFilterAttributes',
    getProfileData: "connector/profile/getProfileData",
    getSearchSuggestions: `connector/product/getSearchSuggestions`,
    exportedFileName: 'connector/csv/exportedFileName',
    importCSV: "connector/csv/importCSV",
    savePartialChunk: 'connector/profile/savePartialChunk',
    getErrorSolution: "connector/product/getErrorSolution",
    getRefineVariant: "connector/product/getRefineVariants",
    getRefineVariantCount: "connector/product/getRefineVariantsCount",
    changeFulfilment: "connector/product/convertFulfilmentType",
}